'use client';

import type { Ref } from 'react';

import type { ButtonProps } from './Button.types';
import { ButtonContent, buttonClasses } from './ButtonContent';

export function Button({
  style,
  children,
  className,
  suffixIcon,
  prefixIcon,
  variant = 'primary',
  size = 'md',
  shadow = false,
  disabled = false,
  loading = false,
  testId = 'ui-button',
  ref,
  ...rest
}: ButtonProps & { ref?: Ref<HTMLButtonElement> }) {
  return (
    <button
      ref={ref}
      style={style}
      className={buttonClasses({
        variant,
        size,
        shadow,
        disabled,
        loading,
        className,
      })}
      disabled={disabled}
      data-testid={testId}
      type="button"
      {...rest}
    >
      <ButtonContent
        prefixIcon={prefixIcon}
        suffixIcon={suffixIcon}
        loading={loading}
        testId={testId}
      >
        {children}
      </ButtonContent>
    </button>
  );
}
